import { textEllipsis, typo } from '@mathflat/common/style'
import type { CSSProperties } from 'react'
import * as React from 'react'

import type { StyleProps } from '@/types'

type Props = {
  smallSizeLength?: number
  maxWidth: CSSProperties['maxWidth']
  minWidth?: CSSProperties['minWidth']
  smallTypo?: keyof typeof typo
  normalTypo?: keyof typeof typo
  children?: string
  textAlign?: CSSProperties['textAlign']
  elipsisLines?: number
} & Omit<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>,
  'children'
> &
  StyleProps

const Name = ({
  textAlign = 'start',
  smallSizeLength = 8,
  smallTypo = 'caption01',
  normalTypo = 'body02',
  elipsisLines = 2,
  maxWidth,
  minWidth,
  ...props
}: Props) => (
  <span
    css={[
      textEllipsis(elipsisLines),
      typo[normalTypo],
      props.children && props.children.length >= smallSizeLength && typo[smallTypo],
    ]}
    style={{ textAlign, maxWidth, minWidth }}
    {...props}
  />
)

export default Name
